import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';

class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    callAppHandle = (isJumpQQlink = false, isCallApp = true) => {
        const { content = {} } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710506194',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8967',
              };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${content.base62Id}`,
        };

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid: content._id,
                kind: 'inter_fxy14',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                ...callImmersiveVideoConfig
            });
        }
    };

    render() {
        const { content = {} } = this.props;
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${content.base62Id}`,
        };
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'share01',
            ...callImmersiveVideoConfig
        });

        return (
            <div className={styles.logoButton} onClick={() => this.callAppHandle()}>
                <span className={styles.logoIcon} />
                <span className={styles.logoText}>APP内打开</span>
                {!content.isVideoShare && (
                    <WxLaunchApp
                        launchType={'app'}
                        launchAppClick={() => this.callAppHandle(false, false)}
                        schemeLink={schemeLink}
                        launchAppFail={() => this.callAppHandle(true, true)}
                    />
                )}
            </div>
        );
    }
}

export default errorBoundary(Logo);
